import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30" }
const _hoisted_3 = { class: "row mb-4" }
const _hoisted_4 = { class: "col-12" }
const _hoisted_5 = { class: "card border" }
const _hoisted_6 = { class: "card-body" }
const _hoisted_7 = { class: "row g-3" }
const _hoisted_8 = { class: "col-md-3 col-sm-6" }
const _hoisted_9 = { class: "col-md-3 col-sm-6" }
const _hoisted_10 = { class: "col-md-3 col-sm-6" }
const _hoisted_11 = { class: "col-md-3 col-sm-6" }
const _hoisted_12 = { class: "col-md-3 col-sm-6" }
const _hoisted_13 = { class: "col-md-3 col-sm-6" }
const _hoisted_14 = { class: "col-md-3 col-sm-6" }
const _hoisted_15 = { class: "col-md-3 col-sm-6 d-flex align-items-end" }
const _hoisted_16 = ["disabled"]
const _hoisted_17 = { class: "row mb-3" }
const _hoisted_18 = { class: "col-12" }
const _hoisted_19 = { class: "table-responsive" }
const _hoisted_20 = { class: "table table-hover" }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { key: 1 }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { key: 1 }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { class: "text-muted" }
const _hoisted_27 = { key: 1 }
const _hoisted_28 = { class: "text-muted" }
const _hoisted_29 = {
  key: 0,
  class: "badge bg-danger"
}
const _hoisted_30 = {
  key: 1,
  class: "badge bg-success"
}
const _hoisted_31 = {
  key: 2,
  class: "badge bg-warning"
}
const _hoisted_32 = { class: "dropdown" }
const _hoisted_33 = {
  class: "dropdown-menu",
  "aria-labelledby": "dropdownActions"
}
const _hoisted_34 = { key: 0 }
const _hoisted_35 = ["onClick"]
const _hoisted_36 = { key: 1 }
const _hoisted_37 = ["onClick"]
const _hoisted_38 = { key: 2 }
const _hoisted_39 = ["onClick"]
const _hoisted_40 = { key: 3 }
const _hoisted_41 = ["onClick"]
const _hoisted_42 = { key: 4 }
const _hoisted_43 = ["onClick"]
const _hoisted_44 = { key: 5 }
const _hoisted_45 = ["onClick"]
const _hoisted_46 = {
  key: 0,
  class: "d-flex justify-content-between align-items-center mt-3"
}
const _hoisted_47 = { class: "text-muted" }
const _hoisted_48 = { class: "pagination mb-0" }
const _hoisted_49 = ["disabled"]
const _hoisted_50 = ["onClick"]
const _hoisted_51 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[22] || (_cache[22] = _createElementVNode("div", { class: "card-header bg-light" }, [
              _createElementVNode("h5", { class: "mb-0" }, [
                _createElementVNode("i", { class: "flaticon-filter me-2" }),
                _createTextVNode("Filtres de recherche ")
              ])
            ], -1)),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _cache[11] || (_cache[11] = _createElementVNode("label", { class: "form-label fw-medium" }, "Mot-clé", -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filtres.motCle) = $event)),
                    type: "text",
                    class: "form-control",
                    placeholder: "Référence, emplacement, usager..."
                  }, null, 512), [
                    [_vModelText, _ctx.filtres.motCle]
                  ])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _cache[12] || (_cache[12] = _createElementVNode("label", { class: "form-label fw-medium" }, "Code emplacement", -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filtres.codeemp) = $event)),
                    type: "text",
                    class: "form-control",
                    placeholder: "Code emplacement"
                  }, null, 512), [
                    [_vModelText, _ctx.filtres.codeemp]
                  ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _cache[13] || (_cache[13] = _createElementVNode("label", { class: "form-label fw-medium" }, "Matricule usager", -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filtres.matricule) = $event)),
                    type: "text",
                    class: "form-control",
                    placeholder: "Matricule"
                  }, null, 512), [
                    [_vModelText, _ctx.filtres.matricule]
                  ])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _cache[15] || (_cache[15] = _createElementVNode("label", { class: "form-label fw-medium" }, "Étape validation", -1)),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filtres.etape_validation) = $event)),
                    class: "form-select"
                  }, [...(_cache[14] || (_cache[14] = [
                    _createElementVNode("option", { value: "" }, "Tous", -1),
                    _createElementVNode("option", { value: "true" }, "Validé", -1),
                    _createElementVNode("option", { value: "false" }, "Non validé", -1)
                  ]))], 512), [
                    [_vModelSelect, _ctx.filtres.etape_validation]
                  ])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _cache[17] || (_cache[17] = _createElementVNode("label", { class: "form-label fw-medium" }, "Statut", -1)),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filtres.resilie) = $event)),
                    class: "form-select"
                  }, [...(_cache[16] || (_cache[16] = [
                    _createElementVNode("option", { value: "" }, "Tous", -1),
                    _createElementVNode("option", { value: "false" }, "Actifs", -1),
                    _createElementVNode("option", { value: "true" }, "Résiliés", -1)
                  ]))], 512), [
                    [_vModelSelect, _ctx.filtres.resilie]
                  ])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _cache[18] || (_cache[18] = _createElementVNode("label", { class: "form-label fw-medium" }, "Date début", -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.filtres.dateDebut) = $event)),
                    type: "date",
                    class: "form-control"
                  }, null, 512), [
                    [_vModelText, _ctx.filtres.dateDebut]
                  ])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _cache[19] || (_cache[19] = _createElementVNode("label", { class: "form-label fw-medium" }, "Date fin", -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.filtres.dateFin) = $event)),
                    type: "date",
                    class: "form-control"
                  }, null, 512), [
                    [_vModelText, _ctx.filtres.dateFin]
                  ])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("button", {
                    onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.rechercher && _ctx.rechercher(...args))),
                    class: "btn btn-primary me-2",
                    disabled: _ctx.loading
                  }, [...(_cache[20] || (_cache[20] = [
                    _createElementVNode("i", { class: "flaticon-search me-1" }, null, -1),
                    _createTextVNode("Rechercher ", -1)
                  ]))], 8, _hoisted_16),
                  _createElementVNode("button", {
                    onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.reinitialiser && _ctx.reinitialiser(...args))),
                    class: "btn btn-secondary"
                  }, [...(_cache[21] || (_cache[21] = [
                    _createElementVNode("i", { class: "flaticon-refresh me-1" }, null, -1),
                    _createTextVNode("Réinitialiser ", -1)
                  ]))])
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", _hoisted_18, [
          (_ctx.checkPrivilege('AddContrat'))
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                to: "/ajouter-contrat",
                class: "btn btn-success"
              }, {
                default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                  _createElementVNode("i", { class: "flaticon-plus me-2" }, null, -1),
                  _createTextVNode("Créer un contrat ", -1)
                ]))]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("table", _hoisted_20, [
          _cache[35] || (_cache[35] = _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", null, "Référence"),
              _createElementVNode("th", null, "Emplacement"),
              _createElementVNode("th", null, "Usager"),
              _createElementVNode("th", null, "Loyer (FCFA)"),
              _createElementVNode("th", null, "Solde initial"),
              _createElementVNode("th", null, "Date création"),
              _createElementVNode("th", null, "Date signature"),
              _createElementVNode("th", null, "Statut"),
              _createElementVNode("th", null, "Actions")
            ])
          ], -1)),
          _createElementVNode("tbody", null, [
            (_ctx.loading)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_21, [...(_cache[24] || (_cache[24] = [
                  _createElementVNode("td", {
                    colspan: "9",
                    class: "text-center"
                  }, [
                    _createElementVNode("div", {
                      class: "spinner-border text-primary",
                      role: "status"
                    }, [
                      _createElementVNode("span", { class: "visually-hidden" }, "Chargement...")
                    ])
                  ], -1)
                ]))]))
              : (_ctx.contrats.length === 0)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_22, [...(_cache[25] || (_cache[25] = [
                    _createElementVNode("td", {
                      colspan: "9",
                      class: "text-center text-muted"
                    }, "Aucun contrat trouvé", -1)
                  ]))]))
                : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.contrats, (contrat) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: contrat.id
                    }, [
                      _createElementVNode("td", null, _toDisplayString(contrat.reference || 'N/A'), 1),
                      _createElementVNode("td", null, [
                        (contrat.codeemp)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(contrat.codeemp.ncode_emp || contrat.codeemp.codeemp), 1))
                          : (_openBlock(), _createElementBlock("span", _hoisted_24, "N/A"))
                      ]),
                      _createElementVNode("td", null, [
                        (contrat.matricule)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_25, [
                              _createTextVNode(_toDisplayString(contrat.matricule.nom) + " " + _toDisplayString(contrat.matricule.prenom) + " ", 1),
                              _cache[26] || (_cache[26] = _createElementVNode("br", null, null, -1)),
                              _createElementVNode("small", _hoisted_26, _toDisplayString(contrat.matricule.matricule), 1)
                            ]))
                          : (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(contrat.locataire || 'N/A'), 1))
                      ]),
                      _createElementVNode("td", null, _toDisplayString(_ctx.formatNumber(contrat.loyer)), 1),
                      _createElementVNode("td", null, [
                        _createElementVNode("span", {
                          class: _normalizeClass(contrat.type_solde === 'Avoir' ? 'text-success' : 'text-danger')
                        }, _toDisplayString(_ctx.formatNumber(contrat.solde_initial)), 3),
                        _cache[27] || (_cache[27] = _createElementVNode("br", null, null, -1)),
                        _createElementVNode("small", _hoisted_28, "(" + _toDisplayString(contrat.type_solde) + ")", 1)
                      ]),
                      _createElementVNode("td", null, _toDisplayString(_ctx.formatDate(contrat.date_creation)), 1),
                      _createElementVNode("td", null, _toDisplayString(_ctx.formatDate(contrat.date_signature)), 1),
                      _createElementVNode("td", null, [
                        (contrat.date_resiliation)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_29, "Résilié"))
                          : (contrat.etape_validation)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_30, "Actif"))
                            : (_openBlock(), _createElementBlock("span", _hoisted_31, "En attente"))
                      ]),
                      _createElementVNode("td", null, [
                        _createElementVNode("div", _hoisted_32, [
                          _cache[34] || (_cache[34] = _createElementVNode("button", {
                            class: "btn btn-sm btn-primary dropdown-toggle",
                            type: "button",
                            id: "dropdownActions",
                            "data-bs-toggle": "dropdown",
                            "aria-expanded": "false"
                          }, [
                            _createElementVNode("i", { class: "flaticon-menu" }),
                            _createTextVNode(" Actions ")
                          ], -1)),
                          _createElementVNode("ul", _hoisted_33, [
                            (_ctx.checkPrivilege('ViewContrat'))
                              ? (_openBlock(), _createElementBlock("li", _hoisted_34, [
                                  _createElementVNode("a", {
                                    class: "dropdown-item",
                                    href: "#",
                                    onClick: _withModifiers(($event: any) => (_ctx.voirDetails(contrat.id)), ["prevent"])
                                  }, [...(_cache[28] || (_cache[28] = [
                                    _createElementVNode("i", { class: "flaticon-eye me-2" }, null, -1),
                                    _createTextVNode("Détail ", -1)
                                  ]))], 8, _hoisted_35)
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.checkPrivilege('EditContrat'))
                              ? (_openBlock(), _createElementBlock("li", _hoisted_36, [
                                  _createElementVNode("a", {
                                    class: "dropdown-item text-success",
                                    href: "#",
                                    onClick: _withModifiers(($event: any) => (_ctx.activerContrat(contrat.id)), ["prevent"])
                                  }, [...(_cache[29] || (_cache[29] = [
                                    _createElementVNode("i", { class: "flaticon-check me-2" }, null, -1),
                                    _createTextVNode("Activer ", -1)
                                  ]))], 8, _hoisted_37)
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.checkPrivilege('EditContrat'))
                              ? (_openBlock(), _createElementBlock("li", _hoisted_38, [
                                  _createElementVNode("a", {
                                    class: "dropdown-item text-warning",
                                    onClick: _withModifiers(($event: any) => (_ctx.desactiverContrat(contrat.id)), ["prevent"])
                                  }, [...(_cache[30] || (_cache[30] = [
                                    _createElementVNode("i", { class: "flaticon-close me-2" }, null, -1),
                                    _createTextVNode("Désactiver ", -1)
                                  ]))], 8, _hoisted_39)
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.checkPrivilege('EditContrat'))
                              ? (_openBlock(), _createElementBlock("li", _hoisted_40, [
                                  _createElementVNode("a", {
                                    class: "dropdown-item text-danger",
                                    onClick: _withModifiers(($event: any) => (_ctx.resilierContrat(contrat.id)), ["prevent"])
                                  }, [...(_cache[31] || (_cache[31] = [
                                    _createElementVNode("i", { class: "flaticon-cancel me-2" }, null, -1),
                                    _createTextVNode("Résiliation ", -1)
                                  ]))], 8, _hoisted_41)
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.checkPrivilege('EditContrat'))
                              ? (_openBlock(), _createElementBlock("li", _hoisted_42, [
                                  _createElementVNode("a", {
                                    class: "dropdown-item text-info",
                                    onClick: _withModifiers(($event: any) => (_ctx.muterContrat(contrat.id)), ["prevent"])
                                  }, [...(_cache[32] || (_cache[32] = [
                                    _createElementVNode("i", { class: "flaticon-exchange me-2" }, null, -1),
                                    _createTextVNode("Mutation ", -1)
                                  ]))], 8, _hoisted_43)
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.checkPrivilege('DeleteContrat'))
                              ? (_openBlock(), _createElementBlock("li", _hoisted_44, [
                                  _createElementVNode("a", {
                                    class: "dropdown-item text-danger",
                                    onClick: _withModifiers(($event: any) => (_ctx.supprimerContrat(contrat.id)), ["prevent"])
                                  }, [...(_cache[33] || (_cache[33] = [
                                    _createElementVNode("i", { class: "flaticon-trash me-2" }, null, -1),
                                    _createTextVNode("Supprimer ", -1)
                                  ]))], 8, _hoisted_45)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ])
                    ]))
                  }), 128))
          ])
        ])
      ]),
      (_ctx.totalPages > 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
            _createElementVNode("div", null, [
              _createElementVNode("span", _hoisted_47, " Page " + _toDisplayString(_ctx.currentPage) + " sur " + _toDisplayString(_ctx.totalPages) + " (" + _toDisplayString(_ctx.totalElements) + " contrats) ", 1)
            ]),
            _createElementVNode("nav", null, [
              _createElementVNode("ul", _hoisted_48, [
                _createElementVNode("li", {
                  class: _normalizeClass(["page-item", { disabled: _ctx.currentPage === 1 }])
                }, [
                  _createElementVNode("button", {
                    class: "page-link",
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.changerPage(_ctx.currentPage - 1))),
                    disabled: _ctx.currentPage === 1
                  }, " Précédent ", 8, _hoisted_49)
                ], 2),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pagesAffichees, (page) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: page,
                    class: _normalizeClass(["page-item", { active: page === _ctx.currentPage }])
                  }, [
                    _createElementVNode("button", {
                      class: "page-link",
                      onClick: ($event: any) => (_ctx.changerPage(page))
                    }, _toDisplayString(page), 9, _hoisted_50)
                  ], 2))
                }), 128)),
                _createElementVNode("li", {
                  class: _normalizeClass(["page-item", { disabled: _ctx.currentPage === _ctx.totalPages }])
                }, [
                  _createElementVNode("button", {
                    class: "page-link",
                    onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.changerPage(_ctx.currentPage + 1))),
                    disabled: _ctx.currentPage === _ctx.totalPages
                  }, " Suivant ", 8, _hoisted_51)
                ], 2)
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}